import React from "react";
import { FiLayout, FiTrendingUp, FiGlobe } from "react-icons/fi";
import "../../styles/AboutSection.css";

export default function VisionSection() {
  return (
    <>
      <section className="about-sub-section vision-section" id="vision">
        <div className="section-header-v2">
          <span className="accent-line"></span>
          <h2>VISION STRATÉGIQUE</h2>
        </div>
        <div className="vision-container">
          <div className="vision-main-statement">
            <h3>Vision Centrale</h3>
            <p className="vision-text-highlight">
              "Contribuer à l'émergence d'un modèle de gouvernance sécuritaire inclusif, innovant et résilient, capable de répondre aux défis complexes du XXIe siècle."
            </p>
          </div>
        </div>
      </section>

      <section className="about-sub-section principles-section">
        <div className="principles-grid-v2">
          <div className="principle-item-v2">
            <span className="principle-bg-num">01</span>
            <div className="principle-header">
              <h4>Sécurité centrée sur l'humain</h4>
            </div>
            <p>Promotion d'approches participatives intégrant les acteurs non étatiques et les dynamiques locales.</p>
          </div>
          
          <div className="principle-item-v2">
            <span className="principle-bg-num">02</span>
            <div className="principle-header">
              <h4>Innovation numérique</h4>
            </div>
            <p>Intégration des technologies émergentes (IA, big data, cybersécurité) dans les systèmes de sécurité.</p>
          </div>

          <div className="principle-item-v2">
            <span className="principle-bg-num">03</span>
            <div className="principle-header">
              <h4>Gouvernance éthique</h4>
            </div>
            <p>Respect des droits fondamentaux, transparence institutionnelle et responsabilité publique.</p>
          </div>

          <div className="principle-item-v2">
            <span className="principle-bg-num">04</span>
            <div className="principle-header">
              <h4>Analyse systémique</h4>
            </div>
            <p>Analyse croisée des risques sécuritaires, environnementaux, numériques et sociétaux.</p>
          </div>
        </div>

        <div className="ambition-pillars-container" id="impact">
          <div className="pillars-header">
            <span className="accent-line"></span>
            <h3>Ambition internationale</h3>
            <p>Trois piliers fondamentaux au service d'une vision globale.</p>
          </div>
          
          <div className="pillars-wrapper">
            <div className="pillar-item pillar-navy">
              <FiLayout className="pillar-bg-icon" />
              <div className="pillar-main">
                <span className="pillar-num">01</span>
                <h4>Hub Académique</h4>
                <p>Un pôle d'excellence pour la recherche et la formation avancée au carrefour des espaces africain et méditerranéen.</p>
              </div>
            </div>

            <div className="pillar-item pillar-red">
              <FiTrendingUp className="pillar-bg-icon" />
              <div className="pillar-main">
                <span className="pillar-num">02</span>
                <h4>Think Tank de Référence</h4>
                <p>Production d'analyses stratégiques à haute valeur ajoutée sur les mutations de la gouvernance sécuritaire.</p>
              </div>
            </div>

            <div className="pillar-item pillar-dark">
              <FiGlobe className="pillar-bg-icon" />
              <div className="pillar-main">
                <span className="pillar-num">03</span>
                <h4>Partenaire Stratégique</h4>
                <p>Développement de réseaux d'expertise et de coopération avec les acteurs majeurs de la sécurité mondiale.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
